<template>
  <div class="error">
    <div class="nav">
      <p>4 0 4</p>
      <span>页面未找到，请先清除浏览器缓存，再刷新页面或</span>
      <el-button @click="handleGoback" type="text">返回上一页</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'notFount',
    methods:{
        handleGoback(){
            this.$router.go(-1)
        }
    }
}
</script>
<style scoped lang="scss">
  .error{
    background: #F4F4F4;
    height: 99vh;
    border: solid 1px #f4f4f4;
    .nav{
      width: 400px;
      margin: 0 auto;
      text-align: center;
      p{
        font-size: 150px;
        color: #CCCCCC;
      }
      span{
        color: #CCCCCC;
      }
    }
  }
</style>
